"use client";

import { useState } from "react";
import Link from "next/link";

const API = "/api/v1";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await fetch(`${API}/auth/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });
      if (!res.ok) {
        const d = await res.json();
        throw new Error(d.error || "요청 실패");
      }
      setSent(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : "요청 실패");
    } finally {
      setLoading(false);
    }
  }

  if (sent) {
    return (
      <div className="mx-auto max-w-sm px-5 py-16 text-center">
        <div className="mb-4 text-4xl">&#9993;</div>
        <h1 className="mb-2 text-xl font-bold">메일 발송 완료</h1>
        <p className="text-muted-foreground mb-6 text-sm">
          입력하신 이메일로 비밀번호 재설정 링크를 발송했습니다.
          <br />
          메일함을 확인해주세요.
        </p>
        <Link href="/signin" className="text-sm font-semibold text-violet-600">
          로그인으로 돌아가기
        </Link>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-sm px-5 py-12">
      <h1 className="mb-2 text-center text-3xl font-extrabold tracking-tight">비밀번호 찾기</h1>
      <p className="text-muted-foreground mb-8 text-center text-sm">
        가입 시 사용한 이메일을 입력해주세요
      </p>

      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          autoComplete="email"
          aria-label="이메일 주소"
          placeholder="you@example.com"
          className="w-full rounded-xl border border-gray-200 px-4 py-3 text-base outline-none focus:border-violet-600"
        />
        {error && (
          <div role="alert" className="rounded-xl bg-red-50 px-4 py-3 text-sm text-red-600">
            {error}
          </div>
        )}
        <button
          type="submit"
          disabled={loading}
          className="rounded-full bg-violet-600 py-3.5 text-base font-bold text-white hover:bg-violet-700 disabled:opacity-50"
        >
          {loading ? "발송 중..." : "재설정 링크 받기"}
        </button>
        <p className="text-muted-foreground text-center text-sm">
          <Link href="/signin" className="font-semibold text-violet-600">
            로그인으로 돌아가기
          </Link>
        </p>
      </form>
    </div>
  );
}
